module.exports = "/assets/festival-banners/listing-banner-gw.png?lptRJ+I";